import React from 'react'
import SVG from 'react-inlinesvg'
import loadingIcon from '../../../images/loading.svg'

const LoadingIcon = ({ visible }) => {
  return (
    <SVG
      src={loadingIcon}
      className="stroke-current"
      style={{
        transition: 'opacity 0.25s',
        opacity: visible ? 1 : 0
      }}
      width={24}
      height={24}
      aria-label="loading"
    />
  )
}

export default LoadingIcon
